/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Description from '../partials/Description';

import styles from '../../../styles/blocks/text.module.css';

const propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    isLeftAligned: PropTypes.bool,
    padded: PropTypes.bool,
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function TextBlock({
    title = null,
    body = null,
    isLeftAligned = false,
    padded = false,
    className = null,
    titleClassName = null,
    bodyClassName = null,
    isContainer = false,
    containerClassName = null,
}) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [styles.isLeftAligned]: isLeftAligned,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <Description
                    titleClassName={classNames([
                        styles.title,
                        { [titleClassName]: titleClassName !== null },
                    ])}
                    bodyClassName={classNames([
                        styles.body,
                        { [bodyClassName]: bodyClassName !== null },
                    ])}
                    title={title}
                    body={body}
                />
            </div>
        </div>
    );
}

TextBlock.propTypes = propTypes;

export default TextBlock;
